import React from 'react';
import Navbar from '../components/home/Navbar';
import Footer from '../components/home/Footer';
import { motion } from 'framer-motion';
import { FaBehance, FaTwitter, FaInstagram, FaDribbble, FaGlobe, FaArrowDown, FaBus, FaPlus, FaMapMarkerAlt, FaUser, FaStar, FaGraduationCap, FaAward } from 'react-icons/fa';

export default function AboutUs() {
    return (
        <div className="min-h-screen bg-blue-50/30 overflow-hidden font-sans">
            <Navbar />

            {/* Main Content Helper Wrapper to avoid Navbar overlap */}
            <div className="pt-24 pb-20 relative">

                {/* Background Gradients/Blobs */}
                <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-blue-100/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 -z-10"></div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <div className="grid lg:grid-cols-2 gap-12 items-center">

                        {/* Left Content */}
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            className="space-y-8"
                        >
                            <div className="inline-block px-4 py-1.5 bg-blue-500 text-white rounded-lg text-sm font-medium mb-4">
                                About Me
                            </div>

                            <h1 className="text-6xl md:text-7xl font-bold text-black leading-tight">
                                Welcome To  <br />
                                Sudesh Maths.
                            </h1>

                            <div className="pt-4 text-gray-600 leading-relaxed text-base space-y-4">
                                <p>
                                    My name is Sudesh Rathnayaka, and I am a dedicated Mathematics tutor with over 5 years of teaching experience, specializing in Grades 6 to 11.
                                </p>
                                <p>
                                    I began my academic journey by passing the Grade 5 Scholarship Examination from Urapola Primary College, which enabled me to enter Bandaranayaka College. I successfully completed both my G.C.E. O/L and A/L examinations in the Mathematics stream (English Medium) and later pursued higher education at the University of Moratuwa.
                                </p>
                                <p>
                                    Over the years, I have helped many students build a strong foundation in mathematics, improve their exam performance, and gain confidence in problem-solving. I am proud to have achieved one of the best mathematics results in the Nittabuwa area in 2024, reflecting my commitment to quality teaching and student success.
                                </p>

                                <div>
                                    <p className="font-semibold text-gray-800 mb-2">Currently, I conduct classes at:</p>
                                    <ul className="list-disc list-inside space-y-1 ml-2">
                                        <li>Sipsara – Gampaha</li>
                                        <li>Vishwa – Nittabuwa</li>
                                        <li>Golden Gate – Kiribathgoda</li>
                                    </ul>
                                </div>

                                <p>
                                    My teaching approach focuses on clear explanations, logical thinking, and exam-oriented practice, ensuring students understand concepts rather than memorize formulas.
                                </p>

                                <div className="pt-4 mt-2 space-y-1 text-gray-800 font-medium">
                                    <p>📘 Brand: Sudesh – Maths</p>
                                    <p>📞 Contact: 071 930 45 66</p>
                                </div>
                            </div>
                        </motion.div>

                        {/* Right Content - Image & Floating Icons */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="relative h-full min-h-[600px] flex items-center justify-center"
                        >
                            {/* Image Container */}
                            <div className="relative z-10 w-[400px] pt-10">
                                <img
                                    src="/hero/about.png"
                                    alt="Profile"
                                    className="w-full h-auto object-cover rounded-3xl z-10 relative mask-image-gradient"
                                    style={{
                                        maskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)',
                                        WebkitMaskImage: 'linear-gradient(to bottom, black 80%, transparent 100%)'
                                    }}
                                />

                                {/* Floating Bubble Icons */}
                                <motion.div
                                    animate={{ y: [0, -10, 0] }}
                                    transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
                                    className="absolute -top-4 -left-8 w-16 h-16 bg-blue-400 rounded-full flex items-center justify-center text-white text-2xl shadow-lg border-4 border-white"
                                >
                                    <span className="font-bold">Bē</span>
                                </motion.div>

                                <motion.div
                                    animate={{ y: [0, -15, 0] }}
                                    transition={{ repeat: Infinity, duration: 4, ease: "easeInOut", delay: 0.5 }}
                                    className="absolute top-20 right-0 w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center text-white text-xl shadow-lg border-4 border-white"
                                >
                                    <FaTwitter />
                                </motion.div>

                                <motion.div
                                    animate={{ y: [0, -12, 0] }}
                                    transition={{ repeat: Infinity, duration: 3.5, ease: "easeInOut", delay: 1 }}
                                    className="absolute bottom-32 -left-4 w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center text-white text-xl shadow-lg border-4 border-white"
                                >
                                    <FaGlobe />
                                </motion.div>

                                <motion.div
                                    animate={{ y: [0, -8, 0] }}
                                    transition={{ repeat: Infinity, duration: 4.5, ease: "easeInOut", delay: 1.5 }}
                                    className="absolute bottom-40 -right-8 w-14 h-14 bg-blue-500 rounded-full flex items-center justify-center text-white text-2xl shadow-lg border-4 border-white"
                                >
                                    <FaInstagram />
                                </motion.div>
                            </div>

                            {/* Circular Gradient Background Behind Image */}
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-white rounded-full shadow-[0_0_100px_rgba(0,0,0,0.05)] -z-0"></div>
                        </motion.div>
                    </div>
                </div>

                {/* Diagonal Banners */}
                <div className="relative h-40 mt-12 overflow-hidden w-full max-w-[100vw]">
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] rotate-3 bg-blue-400 text-white py-4 z-10 flex items-center justify-center overflow-hidden shadow-xl">
                        <div className="flex gap-12 font-bold text-2xl uppercase tracking-wider opacity-80 whitespace-nowrap animate-marquee">
                            {[...Array(10)].map((_, i) => (
                                <span key={i}>Sudesh Rathnayaka | Mathematics </span>
                            ))}
                        </div>
                    </div>
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] -rotate-3 bg-blue-500 text-white py-4 z-20 flex items-center justify-center overflow-hidden shadow-xl">
                        <div className="flex gap-12 font-bold text-2xl uppercase tracking-wider opacity-90 whitespace-nowrap animate-marquee-reverse">
                            {[...Array(10)].map((_, i) => (
                                <span key={i}>Sudesh Rathnayaka | Mathematics</span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Bottom Cards */}
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
                        {[
                            { icon: FaStar, title: "5+ Years Exp.", subtitle: "Mathematics Tutor", active: false },
                            { icon: FaGraduationCap, title: "U. of Moratuwa", subtitle: "Higher Education", active: false },
                            { icon: FaUser, title: "Grade 6-11", subtitle: "English Medium", active: true },
                            { icon: FaAward, title: "Best Results", subtitle: "Nittabuwa Area", active: false },
                            { icon: FaMapMarkerAlt, title: "3 Locations", subtitle: "Gampaha, Nittabuwa...", active: false },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className={`
                            relative p-6 rounded-2xl flex flex-col items-center justify-center text-center gap-3 transition-all duration-300 hover:-translate-y-2
                            ${item.active ? 'bg-blue-500 text-white shadow-xl scale-105' : 'bg-white text-gray-800 shadow-md hover:shadow-lg'}
                        `}
                            >
                                <item.icon className={`text-3xl ${item.active ? 'text-white' : 'text-gray-900'}`} />
                                <div>
                                    <h4 className="font-bold text-sm mb-1">{item.title}</h4>
                                    <p className={`text-[10px] ${item.active ? 'text-blue-100' : 'text-gray-400'}`}>{item.subtitle}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    );
}

// Add animation styles helper in a style tag for the marquee if needed, or stick to basic css.
// We'll rely on tailwind arbitrary values or assume standard config. 
// Ideally should add custom keyframes to index.css but for a single file drop-in:
const style = document.createElement('style');
style.innerHTML = `
@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
@keyframes marquee-reverse {
  0% { transform: translateX(-50%); }
  100% { transform: translateX(0); }
}
.animate-marquee {
  animation: marquee 20s linear infinite;
}
.animate-marquee-reverse {
  animation: marquee-reverse 20s linear infinite;
}
`;
document.head.appendChild(style);
